import { canNotifyMCPMutation, useScopedMCPMutation } from "./useScopedMCPMutation";
import { mcpRequestOptions } from "./useMCPQueryScope";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import {
  agentToolsApi,
  type MCPOAuthInit,
} from "../../../services/agent-tools-service";

type ApiError = {
  response?: {
    data?: { error?: { message?: string }; detail?: string; message?: string };
  };
  message?: string;
};

const extractErrorMessage = (error: ApiError, fallback: string): string => {
  const data = error.response?.data;
  return (
    data?.error?.message ||
    data?.detail ||
    data?.message ||
    error.message ||
    fallback
  );
};

type Options = {
  onSuccess?: (init: MCPOAuthInit) => void;
  onError?: () => void;
};

export const useReconnectMCPConnection = (options: Options = {}) => {
  const { t } = useTranslation();
  return useScopedMCPMutation<MCPOAuthInit, string, undefined, ApiError>({
    mutationFn: (id, scope) => agentToolsApi.oauthLogin(id, mcpRequestOptions(scope)),
    onSuccess: (init, _id, scope) => {
      if (canNotifyMCPMutation(scope)) options.onSuccess?.(init);
    },
    onError: (error: ApiError, _id, _context, scope) => {
      if (!canNotifyMCPMutation(scope, error)) return;
      toast.error(extractErrorMessage(error, t("mcpPage.mutation.reauthorizeFailed")));
      options.onError?.();
    },
  });
};
